/* je-mobile-glass-nav-20260906: two launch points, one existing navigation menu. */
(() => {
  'use strict';
  const dock = document.getElementById('je-mobile-glass-nav');
  const menu = document.querySelector('[data-je-photo-menu]');
  if (!dock || dock.dataset.ready) return;
  // Home must remain usable even if a future header omits its menu.
  dock.hidden = false;
  document.body.classList.add('je-mobile-nav-ready');
  if (!menu) {
    dock.dataset.homeOnly = 'true';
    return;
  }
  const picker = dock.querySelector('.je-mobile-glass-nav__picker');
  const summary = menu.querySelector(':scope > summary');
  const panel = menu.querySelector(':scope > .je-photo-menu__panel');
  if (!picker || !summary || !panel) return;
  const mobile = matchMedia('(max-width: 900px)');
  panel.id = panel.id || 'je-shared-navigation-panel';
  picker.setAttribute('aria-controls', panel.id);
  summary.setAttribute('aria-controls', panel.id);
  let origin = null;

  function sync() {
    dock.dataset.menuOpen = String(menu.open);
    picker.setAttribute('aria-expanded', String(menu.open));
    picker.setAttribute('aria-label', menu.open ? 'Close menu' : 'Open menu');
    summary.setAttribute('aria-expanded', String(menu.open));
    if (!menu.open) {
      if (panel.contains(document.activeElement)) {
        (origin === 'dock' && mobile.matches ? picker : summary).focus({ preventScroll: true });
      }
      delete menu.dataset.jeMenuOrigin;
    }
  }
  function openFromDock(focusFirst) {
    origin = 'dock';
    menu.dataset.jeMenuOrigin = 'dock';
    menu.open = true;
    sync();
    if (focusFirst) requestAnimationFrame(() => {
      if (menu.open && origin === 'dock') panel.querySelector('a, summary')?.focus({ preventScroll: true });
    });
  }
  picker.addEventListener('click', event => {
    // The existing header dismisses outside clicks. This is its second trigger.
    event.stopPropagation();
    if (menu.open && origin === 'dock') { menu.open = false; sync(); }
    else openFromDock(event.detail === 0);
  });
  picker.addEventListener('keydown', event => {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      openFromDock(true);
    }
  });
  summary.addEventListener('click', () => {
    origin = 'header';
    delete menu.dataset.jeMenuOrigin;
  });
  // Run before the existing Escape listener so it sees a closed menu and leaves
  // focus on the bottom button that opened it. Other Escape handlers still run.
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu.open && origin === 'dock') {
      event.preventDefault();
      menu.open = false;
      picker.focus({ preventScroll: true });
      sync();
    }
  }, true);
  menu.addEventListener('toggle', sync);
  const closeForDesktop = () => {
    if (!mobile.matches && origin === 'dock') { menu.open = false; sync(); }
  };
  mobile.addEventListener('change', closeForDesktop);
  window.addEventListener('pageshow', event => { if (event.persisted) { menu.open = false; sync(); } });

  // Use the purchase bar's existing visibility signal and actual height. No new
  // scroll handler or per-frame geometry measurements are needed.
  // Keep a stable return point outside the transformed purchase bar.
  const dockHome = document.createComment('mobile navigation return point');
  dock.before(dockHome);
  const homeLink = dock.querySelector('.je-mobile-glass-nav__home');
  const divider = dock.querySelector('.je-mobile-glass-nav__divider');
  function placeDock(bar, integrated) {
    if (integrated && dock.parentElement !== bar) {
      if (homeLink) dock.prepend(homeLink);
      bar.prepend(dock);
    } else if (!integrated && dock.parentElement === bar) {
      dockHome.after(dock);
      if (picker && divider) dock.insertBefore(picker, divider);
      if (homeLink) dock.append(homeLink);
    }
    dock.dataset.integrated = String(integrated);
    bar.dataset.jeNavIntegrated = String(integrated);
    document.body.classList.toggle('je-mobile-nav-integrated', integrated);
  }
  function bindPurchaseClearance() {
    const bar = document.getElementById('pdpbar');
    if (!bar) return false;
    if (bar.dataset.jeMobileNavMeasured) return true;
    bar.dataset.jeMobileNavMeasured = 'true';
    const update = () => {
      const style = getComputedStyle(bar);
      const visible = bar.classList.contains('on') && style.display !== 'none';
      placeDock(bar, mobile.matches && visible);
      const lift = visible
        ? Math.ceil(bar.offsetHeight + (parseFloat(style.bottom) || 0)) : 0;
      document.documentElement.style.setProperty('--je-mobile-nav-lift', lift + 'px');
    };
    new MutationObserver(update).observe(bar, { attributes: true, attributeFilter: ['class'] });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(bar);
    mobile.addEventListener('change', update);
    update();
    return true;
  }
  if (!bindPurchaseClearance()) {
    const tour = document.querySelector('.je-tour-root');
    if (tour) {
      const pending = new MutationObserver(() => { if (bindPurchaseClearance()) pending.disconnect(); });
      pending.observe(tour, { childList: true, subtree: true });
      window.addEventListener('load', () => { bindPurchaseClearance(); pending.disconnect(); }, { once: true });
    }
  }
  dock.dataset.ready = 'true';
  dock.hidden = false;
  document.body.classList.add('je-mobile-nav-ready');
  sync();
})();

/* je-mobile-collection-tray-20261022: one occupied area for stock, navigation and Chat.
   The collection remains the only stock-state owner. These buttons forward to its
   existing controls and observe their result; they never query or change products. */
(() => {
  'use strict';
  const dock = document.getElementById('je-mobile-glass-nav');
  const source = document.querySelector('[data-je-stock-switch]');
  if(document.documentElement.classList.contains('je-stock-tray-fallback')) return;
  if (!dock || !source || dock.dataset.stockTray) return;
  const originals = [...source.querySelectorAll('[data-cmain-tab]')];
  if (originals.length !== 2) return;
  const mobile = matchMedia('(max-width: 900px)');
  const tray = document.createElement('div');
  tray.className = 'je-mobile-stock-options';
  tray.setAttribute('role', 'group');
  tray.setAttribute('aria-label', source.getAttribute('aria-label') || 'Choose stock type');
  const options = originals.map(original => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'je-mobile-stock-option';
    const label = document.createElement('span');
    label.className = 'je-mobile-stock-label';
    const count = document.createElement('span');
    count.className = 'je-mobile-stock-count';
    const extra = document.createElement('small');
    extra.className = 'je-mobile-stock-extra';
    button.append(label, count, extra);
    button.addEventListener('click', () => { original.click(); sync(); });
    tray.append(button);
    return { original, button, label, count, extra };
  });
  function setText(node, value) { if (node.textContent !== value) node.textContent = value; }
  function sync() {
    for (const { original, button, label, count, extra } of options) {
      const selected = original.getAttribute('aria-selected') === 'true';
      button.setAttribute('aria-pressed', String(selected));
      button.disabled = original.disabled;
      const name = original.dataset.cmainTab === 'instock' ? 'In Stock' : 'Available to Order';
      setText(label, name);
      setText(count, original.querySelector('[data-cmain-tab-count]')?.textContent.trim() || '');
      setText(extra, original.querySelector('small')?.textContent.trim() || '');
      extra.hidden = !extra.textContent;
    }
  }
  function space() {
    if (mobile.matches) {
      document.documentElement.style.setProperty('--je-mobile-stock-space', `${dock.offsetHeight + 24}px`);
    }
  }
  function activate() {
    document.body.classList.toggle('je-mobile-stock-tray', mobile.matches);
    space();
  }
  dock.prepend(tray);
  dock.dataset.stockTray = 'true';
  new MutationObserver(sync).observe(source, { attributes: true, attributeFilter: ['aria-selected', 'disabled'], childList: true, characterData: true, subtree: true });
  if ('ResizeObserver' in window) new ResizeObserver(space).observe(dock);
  mobile.addEventListener('change', activate);
  window.addEventListener('pageshow', () => { sync(); activate(); });
  sync();
  activate();
})();
